<template>
  <t-page>
    <h3 slot="header">
      {{ $t('pages.help.heading') }}
    </h3>
    <t-grid>
      <t-grid-row>
        <t-grid-cell :size="6">
          <t-card>
            <t-grid>
              <t-grid-row>
                <t-grid-cell :size="8">
                  <h2>{{ $t('pages.help.getting_started.heading') }}</h2>
                  <p>
                    {{ $t('pages.help.getting_started.lead') }}
                  </p>
                </t-grid-cell>
                <t-grid-cell
                  :size="4"
                  style="display: flex; justify-content: flex-end"
                >
                  <t-icon
                    :icon="['far', 'question-circle']"
                    boxed
                  />
                </t-grid-cell>
              </t-grid-row>
            </t-grid>
          </t-card>
        </t-grid-cell>
        <t-grid-cell :size="6">
          <t-card>
            <t-grid>
              <t-grid-row>
                <t-grid-cell :size="8">
                  <h2>{{ $t('pages.help.support.heading') }}</h2>
                  <p>
                    {{ $t('pages.help.support.lead') }}
                  </p>
                  <!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
                  <span
                    >{{ $t('fields.support_email') }}:
                    <a :href="`mailto:${tenant.tenant.meta.support_email}`">{{
                      tenant.tenant.meta.support_email
                    }}</a></span
                  >
                  <!-- eslint-enable @intlify/vue-i18n/no-raw-text -->
                </t-grid-cell>
                <t-grid-cell
                  :size="4"
                  style="display: flex; justify-content: flex-end"
                >
                  <t-icon
                    icon="phone"
                    boxed
                  />
                </t-grid-cell>
              </t-grid-row>
            </t-grid>
          </t-card>
        </t-grid-cell>
      </t-grid-row>
    </t-grid>
  </t-page>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
  computed: {
    ...mapState(['tenant']),
  },
});
</script>
